import Vue from 'vue';
import { merge } from 'Utils/common';

// Merge strategy for staticData options
Vue.config.optionMergeStrategies.staticData = (toVal, fromVal) => {
  if (!toVal) return fromVal;
  if (!fromVal) return toVal;
  return function mergeValidations() {
    const toValObj = typeof toVal === 'function' ? toVal.call(this) : toVal;
    const fromValObj = typeof fromVal === 'function' ? fromVal.call(this) : fromVal;
    merge(toValObj, fromValObj);
    return toValObj;
  };
};

export default {
  beforeCreate() {
    this.__prerender = window.__prerender;
    this.__prerendered = window.__prerendered;
    this.__hydration = window.__hydration;
    const { staticData } = this.$options;
    if (staticData && typeof staticData === 'function') {
      Object.assign(this, staticData.apply(this));
    } else if (staticData && typeof staticData === 'object') {
      Object.assign(this, staticData);
    }
  },
};
